import React from "react";
import {Container} from "react-bootstrap";
import FooterTFAF from "./FooterTFAF";
import {regularTextStyles} from "../Style";

const Expired = props => {
    const handleNewQuoteClick = () => {
        window.location.href = '/vehicle';
    };
    return (

        <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
            <Container fluid style={{flex: 1}}>
                <Container>
                    <br/>
                    <br/>

                    <p style={regularTextStyles}>Your original quote is no longer valid.</p>

                    <p style={regularTextStyles}> If you’re still interested in car insurance, please
                        get a {' '}
                        <span style={{
                            color: '#1851A3', textDecoration: "underline",
                            cursor: "pointer",
                        }}
                              onClick={handleNewQuoteClick}>
                      new quote
                </span>.</p>

                    <br/><br/><br/><br/>
                </Container>
            </Container>
            <FooterTFAF/>
        </div>

    );
}

export default Expired;
